import { useEffect, useState } from "react";

export const useItemExpand = <T>(items: T[]) => {
  const [expanded, setExpanded] = useState<boolean[]>([]);

  useEffect(() => {
    setExpanded(items.map(() => false));
  }, [items]);

  const toggleExpand = (index: number) => setExpanded(prev => {
    const expanded = [...prev];
    expanded[index] = !expanded[index];

    return expanded;
  });

  const expandAll: () => void = () => setExpanded(items.map(() => true));
  const hideAll = () => setExpanded(items.map(() => false));

  const isAllExpanded = expanded.every(i => i) && expanded.length === items.length;

  return [expanded, isAllExpanded, toggleExpand, expandAll, hideAll] as const;
}
